import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  systemStats: null,
  academicYears: [],
  loading: false
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setSystemStats: (state, action) => {
      state.systemStats = action.payload;
    },
    setAcademicYears: (state, action) => {
      state.academicYears = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const {
  setSystemStats,
  setAcademicYears,
  setLoading
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
